import { IsEnum, IsNotEmpty, IsString, IsUUID } from 'class-validator';
import { Gender } from './ReceiptBatchControllerDefinition';

export class GetResidentQueryDto {
  @IsNotEmpty()
  @IsUUID(4)
  nursingHomeId!: string;
  @IsNotEmpty()
  @IsUUID(4)
  globalServiceProviderId!: string;
}

export class GetResidentResultEntryDto {
  @IsNotEmpty()
  @IsUUID()
  id!: string;
  @IsNotEmpty()
  @IsString()
  firstName!: string;
  @IsNotEmpty()
  @IsString()
  lastName!: string;
  @IsNotEmpty()
  @IsEnum(Gender)
  gender!: Gender;
}

export const ResidentControllerDefinition = {
  controller: 'residents',
  endpoints: {
    getResidentList: {
      method: 'GET',
      url: '',
      response: undefined as unknown as GetResidentResultEntryDto[],
      body: undefined,
      query: undefined as unknown as GetResidentQueryDto,
    },
  },
} as const;

export type ResidentControllerResultTypes = {
  [key in keyof (typeof ResidentControllerDefinition)['endpoints']]: (typeof ResidentControllerDefinition)['endpoints'][key]['response'];
};
export type ResidentControllerQueryTypes = {
  [key in keyof (typeof ResidentControllerDefinition)['endpoints']]: (typeof ResidentControllerDefinition)['endpoints'][key]['query'];
};
export type ResidentControllerBodyTypes = {
  [key in keyof (typeof ResidentControllerDefinition)['endpoints']]: (typeof ResidentControllerDefinition)['endpoints'][key]['body'];
};
